import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_USER_PROGRAM_ACTIVE_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_USER_PROGRAM_ACTIVE_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_USER_PROGRAM_ACTIVE_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/user-programs/${id}/active`,
    method: 'POST',
    notify: true,
  })
);

export default apiCall;
